// eslint-disable-next-line
import React, { ExoticComponent, ReactNode, Suspense, SuspenseProps } from 'react';

import { isRenderedOnServer } from '../../../utils/envUtils';

export default (
  props: React.PropsWithChildren<SuspenseProps>,
): ExoticComponent<SuspenseProps> | NonNullable<ReactNode> | null => {
  if (isRenderedOnServer()) {
    return props.fallback;
  }

  // eslint-disable-next-line react/destructuring-assignment
  return <Suspense fallback={props.fallback}>{props.children}</Suspense>;
};
